export const theme = {
  colors: {
    primary: '#2B6CB0',
    secondary: '#4299E1',
    background: '#F7FAFC',
    white: '#FFFFFF',
    text: {
      primary: '#2D3748',
      secondary: '#718096',
    },
    border: '#E2E8F0',
    shadow: 'rgba(0, 0, 0, 0.1)',
  },
};
